import React from 'react'

const HomeIcon = () => {
    return (
        <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.49994 0.000131283C2.46667 0.000131283 0 2.55679 0 5.70093C0 6.87827 0.350589 7.97541 0.942529 8.88461L1.49696 8.43065C1.00044 7.64804 0.709733 6.70944 0.709733 5.7008C0.709733 2.95427 2.85021 0.735588 5.5 0.735588C8.14979 0.735588 10.2903 2.95424 10.2903 5.7008C10.2903 6.70944 9.99956 7.64804 9.50291 8.43052L10.0573 8.88448C10.6494 7.97525 11 6.8781 11 5.7008C11 2.55676 8.5333 0 5.50006 0L5.49994 0.000131283ZM8.63804 3.55164L5.48337 5.88486C5.26147 5.88897 5.0428 5.9794 4.87349 6.15501C4.52709 6.51407 4.52709 7.09463 4.87349 7.45382C5.2199 7.81288 5.78 7.81288 6.12654 7.45382C6.29584 7.27834 6.38333 7.05168 6.38717 6.82167L8.63818 3.55179L8.63804 3.55164Z" fill="Black" />
        </svg>
    )
}

export default HomeIcon